<template>
  <vue-page-wrapper
    :title="htmlTitle"
    :bread-crumbs="breadCrumbItems"
    extraInfo="no-margin"
  >
    <vue-carousel
      :key="`contact-carousel-${stats.medium_wise_stat.length}`"
      from="contact-person"
      :options="{
        perPage: {
          0: 2,
          800: 4, // 4 items for viewport wider than 800px
          1240: 4 // 4 items for viewport wider than 1240px
        }
      }"
      :show-button="true"
    >
      <template
        v-if="stats && stats.medium_wise_stat && stats.medium_wise_stat.length"
        slot="carousel"
      >
        <v-card class="mr-3 ml-1 my-1"
          ><v-row class="px-3">
            <v-col cols="5" class="pr-2">
              <div class="stat-title grey--text mb-2">Total Contacts</div>
              <div>
                <span
                  @click="
                    (filter.all_completed = null),
                      (filter.available = ''),
                      (filter.unavailable = ''),
                      (filter.has_communication_medium = null)
                  "
                  class="title indigo--text font-weight-bold pointer"
                  >{{ stats.aggregate.total || "0" }}</span
                >
              </div>
            </v-col>
            <v-col class="text-center px-0" cols="1"
              ><v-divider vertical></v-divider
            ></v-col>

            <v-col cols="6"
              ><div class="stat-title grey--text mb-2">
                100% Completed
              </div>
              <div
                class="title green--text text--darken-3 font-weight-bold pointer"
                @click="
                  (filter.all_completed = true),
                    (filter.available = ''),
                    (filter.unavailable = ''),
                    (filter.has_communication_medium = null)
                "
              >
                {{ stats.aggregate.completed || "0" }}
              </div></v-col
            ></v-row
          ></v-card
        >
        <v-card
          class="mr-3 ml-1 my-1"
          v-for="(item, index) in stats.medium_wise_stat"
          :key="`stat-${index}`"
        >
          <v-row v-if="item.medium_contacts__medium" class="px-3">
            <v-col cols="5" class="pr-0">
              <div class="stat-title grey--text mb-2">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <span>
                        <v-icon small>{{
                          $options.mediumIcons[
                            item.medium_contacts__medium__icon
                          ]
                        }}</v-icon>
                      </span>
                      <span>
                        Available
                      </span>
                    </div>
                  </template>
                  <span>{{ item.medium_contacts__medium__name || "-" }}</span>
                </v-tooltip>
              </div>
              <div>
                <span
                  @click="
                    (filter.all_completed = null),
                      (filter.available = item.medium_contacts__medium),
                      (filter.unavailable = ''),
                      (filter.has_communication_medium = null)
                  "
                  class="title green--text text--darken-2 font-weight-bold pointer"
                  >{{ item.count }}</span
                >
              </div>
            </v-col>
            <v-col class="text-center px-0" cols="2"
              ><v-divider vertical></v-divider
            ></v-col>

            <v-col cols="5" class="pl-0"
              ><div class="stat-title grey--text mb-2">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <span>
                        <v-icon small>{{
                          $options.mediumIcons[
                            item.medium_contacts__medium__icon
                          ]
                        }}</v-icon>
                      </span>
                      <span>
                        Unavailable
                      </span>
                    </div>
                  </template>
                  <span>{{ item.medium_contacts__medium__name || "-" }}</span>
                </v-tooltip>
              </div>
              <div
                @click="
                  (filter.all_completed = null),
                    (filter.available = ''),
                    (filter.unavailable = item.medium_contacts__medium),
                    (filter.has_communication_medium = null)
                "
                class="title red--text text--lighten-1 font-weight-bold pointer"
              >
                {{
                  stats.aggregate.total
                    ? stats.aggregate.total - item.count
                    : "-"
                }}
              </div></v-col
            ></v-row
          >
          <v-row v-else class="px-3">
            <v-col cols="5" class="pr-0">
              <div class="stat-title grey--text mb-2">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <span>
                        Registered
                      </span>
                    </div>
                  </template>
                  <span>Communication Medium Registered</span>
                </v-tooltip>
              </div>
              <div>
                <span
                  @click="
                    (filter.all_completed = null),
                      (filter.available = ''),
                      (filter.unavailable = ''),
                      (filter.has_communication_medium = true)
                  "
                  class="title green--text text--darken-2 font-weight-bold pointer"
                  >{{
                    stats.aggregate.total
                      ? stats.aggregate.total - item.count
                      : "-"
                  }}</span
                >
              </div>
            </v-col>
            <v-col class="text-center px-0" cols="1"
              ><v-divider vertical></v-divider
            ></v-col>

            <v-col cols="6" class="pl-0"
              ><div class="stat-title grey--text mb-2">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <span>
                        Not Registered
                      </span>
                    </div>
                  </template>
                  <span>Communication Medium Not Registered</span>
                </v-tooltip>
              </div>
              <div
                @click="
                  (filter.all_completed = null),
                    (filter.available = ''),
                    (filter.unavailable = ''),
                    (filter.has_communication_medium = false)
                "
                class="title red--text text--lighten-1 font-weight-bold pointer"
              >
                {{ item.count || "-" }}
              </div></v-col
            ></v-row
          >
        </v-card>
      </template>
    </vue-carousel>
    <v-card class="mt-3 mx-1">
      <vue-card-title
        :title="'Contact Directory'"
        :subtitle="'List of client Directory'"
        :icon="$getIcon('mdiContacts')"
      >
        <template slot="actions">
          <v-btn
            small
            @click="
              selectedContactPerson = undefined;
              drawer = true;
            "
            class="primary"
            >Create New Contact</v-btn
          >
          <v-btn icon @click="filter.show = !filter.show">
            <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-slide-y-transition>
          <v-row v-if="filter.show" class="mx-2">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="filter.search"
                label="Search By Name"
                :prepend-inner-icon="$getIcon('mdiMagnify')"
                clearable
                @keypress.enter="fetchDataTable"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-slide-y-transition>
        <v-divider v-if="filter.show"></v-divider>
        <v-data-table
          :headers="headers"
          :items="fetchedResults"
          :loading="loading"
          :sort-desc.sync="pagination.descending"
          :sort-by.sync="pagination.sortBy"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.rowsPerPage"
          :footer-props="footerProps"
          :server-items-length="pagination.totalItems"
          must-sort
          class="elevation-1"
          mobile-breakpoint="0"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <v-row align="center" no-gutters>
                  <v-avatar class="pointer" :size="35">
                    <v-img
                      :src="
                        $getProp(props.item, 'image') ||
                          require(`@/static/images/info/user-default.png`)
                      "
                      alt="contact avatar"
                    ></v-img>
                  </v-avatar>
                  <v-col class="text-left ml-2">
                    <div class="pointer font-weight-bold">
                      {{ $getProp(props.item, "name") || "Fix null" }}
                    </div>
                    <div class="pointer caption grey--text">
                      {{
                        props.item.designation
                          ? props.item.designation.name
                          : "-"
                      }}
                    </div>
                  </v-col>
                </v-row>
              </td>
              <td>
                <div class="font-weight-bold">
                  {{ props.item.client_name ? props.item.client_name : "-" }}
                </div>
              </td>
              <td>
                <div
                  v-for="item in props.item.medium_contacts"
                  :key="item.icon_name"
                >
                  <span v-if="validEmail(item.contact)">
                    <span>
                      <v-icon
                        small
                        v-text="$options.mediumIcons[item.icon_name]"
                      ></v-icon>
                    </span>
                    <span class="px-2">{{ item.contact }}</span>
                  </span>
                </div>
              </td>
              <td>
                <div
                  v-for="item in props.item.medium_contacts"
                  :key="item.icon_name"
                >
                  <span v-if="!validEmail(item.contact)">
                    <span>
                      <v-icon
                        small
                        v-text="$options.mediumIcons[item.icon_name]"
                      ></v-icon>
                    </span>
                    <span class="px-2">{{ item.contact }}</span>
                  </span>
                </div>
              </td>
              <!-- <td v-if="props.item.medium_contacts.length">
                <span>
                  <v-icon
                    small
                    v-text="
                      $options.mediumIcons[
                        props.item.medium_contacts[0].icon_name
                      ]
                    "
                  ></v-icon>
                </span>
                <span>
                  {{ props.item.medium_contacts[0].contact }}
                </span>
                <span v-if="props.item.medium_contacts.length > 1">
                  <v-menu open-on-hover offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        class="grey lighten-2 font-weight-bold blue--text text--darken-2"
                        icon
                        >+{{ props.item.medium_contacts.length - 1 }}</v-btn
                      >
                    </template>

                    <v-list dense>
                      <v-list-item
                        v-for="(contact,
                        index) in props.item.medium_contacts.filter(
                          (each, ind) => {
                            if (ind) {
                              return each;
                            }
                          }
                        )"
                        :key="index"
                      >
                        <v-list-item-title>
                          <span>
                            <v-icon
                              small
                              v-text="$options.mediumIcons[contact.icon_name]"
                            ></v-icon>
                          </span>
                          <span class="body-2">
                            {{ contact.contact }}
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </span>
              </td> -->
              <!-- <td v-else>-</td> -->
              <td v-if="props.item.last_contacted">
                <div>
                  {{ $dayjs(props.item.last_contacted).format("DD-MM-YYYY") }}
                </div>
                <div>
                  {{ $dayjs(props.item.last_contacted).format("hh:mmA") }}
                </div>
              </td>
              <td v-else>-</td>
              <td align="center">
                <v-menu offset-y left transition="slide-y-transition">
                  <template v-slot:activator="{ on }">
                    <v-btn small text icon v-on="on">
                      <v-icon v-text="$getIcon('mdiDotsVertical')"></v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="pa-0">
                    <v-list-item
                      @click="
                        selectedContactPerson = props.item;
                        drawer = true;
                      "
                      class="pointer"
                    >
                      <v-list-item-title>
                        <v-icon
                          disabled
                          small
                          color="grey"
                          v-text="$getIcon('mdiEye')"
                        ></v-icon>
                        <span
                          class="ml-1 grey--text text--darken-2"
                          v-text="'Update Contact'"
                        ></span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <vue-data-table-no-data :loading="loading"></vue-data-table-no-data>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <div>
      <v-navigation-drawer
        width="900"
        v-model="drawer"
        right
        temporary
        fixed
        clipped
      >
        <template v-slot:prepend>
          <v-card tile>
            <vue-card-title
              :title="contactPersonFormTitle"
              dark
              :subtitle="'Fill up the following form to action on client data.'"
              :icon="$getIcon('mdiFileDocumentEdit')"
              closable
              @close="(drawer = false), (selectedContactPerson = undefined)"
            >
            </vue-card-title>
            <v-divider></v-divider>
          </v-card>
        </template>
        <contact-person-form
          v-if="drawer"
          :action-data="
            selectedContactPerson ? selectedContactPerson : undefined
          "
          @close="drawer = false"
          @contactPersonFormResponse="formSuccess()"
        >
        </contact-person-form>
      </v-navigation-drawer>
    </div>
  </vue-page-wrapper>
</template>
<script>
import DataTableMixin from "@/mixins/dataTableMixin";
import VueCarousel from "@/components/common/layout_utils/VueCarousel";
import ContactPersonForm from "@/components/crm/client/forms/ContactPersonForm";
import mediumIcons from "@/utils/mediumIcons.js";
import cancelRequestMixin from "@/mixins/cancelRequestMixin";

export default {
  mixins: [DataTableMixin, cancelRequestMixin],
  components: {
    VueCarousel,
    ContactPersonForm
  },
  mediumIcons,
  data() {
    return {
      htmlTitle: "Contact Persons",
      stats: {
        aggregate: {},
        medium_wise_stat: []
      },
      drawer: false,
      breadCrumbItems: [{ text: "Contact Directory", disabled: true }],
      fetchAPI: `/api/v1/crm/client-contact-person/?client__organization__slug=${this.$store.state.shell.currentOrganizationId}&limit=5`,
      filter: {
        search: "",
        show: false,
        all_completed: null,
        has_communication_medium: null,
        available: "",
        unavailable: ""
      },
      carouselKey: 3,
      selectedContactPerson: undefined,
      headers: [
        {
          text: "Contact Name",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Organization",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Contact No.",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Last Contacted",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          class: "grey lighten-4"
        }
      ]
    };
  },
  computed: {
    DataTableFilter() {
      return {
        search: this.filter.search,
        all_completed: this.filter.all_completed,
        has_communication_medium: this.filter.has_communication_medium,
        available: this.filter.available,
        unavailable: this.filter.unavailable
      };
    },
    contactPersonFormTitle() {
      let action = this.selectedContactPerson ? "Update" : "Create";
      return `${action} Contact Person`;
    }
  },
  mounted() {
    this.getStats();
  },
  methods: {
    getStats() {
      this.$axios
        .$get("/api/v1/crm/client-contact-person/stats/")
        .then(response => {
          this.stats = response;
        });
    },
    formSuccess() {
      this.fetchDataTable();
    },
    fetchDataTable() {
      this.loading = true;
      this.checkRequest();
      this.$axios
        .$get(this.fetchAPI, {
          params: this.fullParams,
          cancelToken: this.axiosSource.token
        })
        .then(response => {
          this.clearOldRequest("Success");
          this.loadDataTable(response);
          this.loading = false;
        });
    },
    validEmail(email) {
      var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    }
  }
};
</script>
<style scoped>
.stat-title {
  font-size: 12px;
}
</style>
